module.exports = __webpack_public_path__ + "img/close-btn.6be1c77a.svg";